/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import {registerInternalPlugin} from '@ciscospark/spark-core';
import User from './user';
import config from './config';

import '@ciscospark/internal-plugin-wdm';

registerInternalPlugin('user', User, {
  config
});

export {default} from './user';
